import React from 'react';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { getDealsUrl } from 'client/site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

import './models-list.scss';

export function ModelsList({ models }) {
  return (
    <ul className="models-list list-unstyled px-0 mb-2">
      {models.map(({ year, makeName, modelName, makeSlug, modelSlug }) => (
        <li
          key={`${year}-${modelName}`}
          className="models-list-item py-1 px-0 ps-md-1_5 pe-md-1 d-flex flex-column flex-md-row justify-content-between"
        >
          <span className="fw-bold">
            {year} {makeName} {modelName}
          </span>
          <Link
            to={getDealsUrl({ makeSlug, modelSlug, year })}
            className="text-primary-darker"
            data-tracking-id="mmy_select"
            data-tracking-value={`${makeName} ${modelName} ${year}`}
          >
            View incentives <span className="icon-arrow-right4 xsmall" aria-hidden />
          </Link>
        </li>
      ))}
    </ul>
  );
}

ModelsList.propTypes = {
  models: VehicleEntities.ModelYearsByMakeId.isRequired,
};
